import api from '@/services/utils/apiInstance'

class RepairCenterService {
  async getPaginatedRepairCenterListByRepairerId(
    search,
    sort,
    order,
    page,
    limit,
    repairerId,
    signal
  ) {
    const url =
      '/admin/repair-center/list-by-repairer-id/' +
      repairerId +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url, { signal })
    return response.data
  }

  async getPaginatedRepairCenterListByStoreId(
    search,
    sort,
    order,
    page,
    limit,
    storeId,
    signal = undefined
  ) {
    const url =
      '/admin/repair-center/list-by-store-id/' +
      storeId +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url, { signal })
    return response.data
  }

  async getPaginatedRepairCenterListByOperatingCenterId(
    search,
    sort,
    order,
    page,
    limit,
    operatingCenterId,
    signal = undefined
  ) {
    const url =
      '/admin/repair-center/list-by-operating-center-id/' +
      operatingCenterId +
      '?search=' +
      encodeURIComponent(search) +
      '&sort=' +
      sort +
      '&order=' +
      order +
      '&page=' +
      page +
      '&limit=' +
      limit
    const response = await api.get(url, { signal })
    return response.data
  }

  async getRepairCenter(repairerCenterId) {
    const response = await api.get('/admin/repair-center/' + repairerCenterId)
    return response.data
  }

  async createRepairCenter(data) {
    const response = await api.post('/admin/repair-center', data)
    return response.data
  }

  async updateRepairCenter(data, repairCenterId) {
    const response = await api.put(`/admin/repair-center/${repairCenterId}`, data)
    return response.data
  }

  async deleteRepairCenter(repairCenterId) {
    const response = await api.delete('/admin/repair-center/' + repairCenterId)
    return response.data
  }

  async getRepairCenterByRepairFile(repairFileId) {
    const response = await api.get('/admin/repair-center/repair-file/' + repairFileId)
    return response.data
  }

  async getRepairCenterByNetworkId(networkId) {
    const response = await api.get('/admin/repair-center/list-by-network-id/' + networkId)
    return response.data
  }
}

export default new RepairCenterService()
